
export var baseThemeStyleName = 'theme-base';
export var flagIconClassesPrefixName = 'flag-icon';
export var flagIconClassesPrefix = flagIconClassesPrefixName + '-';
export var flagIconModulePath = 'node_modules/flag-icon-css';


//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-flag-icon-css/module/functions/constants.js
// module id = 237
// module chunks = 0